// Copy for the generic /adviser routing page, transcribed from the approved
// mockup (docs/omw419/copy/Adviser_page.txt). Channel pages reuse the link
// cards with "Additional Resources" as the second title.

export const ADVISER_INTRO = {
  heading: 'Why Wills matter',
  lead: "85% of South Africans die without a valid Will (Master of the High Court, 2022) — possibly leaving the people they love exposed when the unexpected happens. As a trusted adviser, you're in a position to change that.",
  paragraphs: [
    'The <strong>Old Mutual Will platform</strong> makes it simpler than ever to help your clients <strong>put a valid Will in place</strong> and plan ahead for when they are no longer there.',
  ],
};

export const ADVISER_GROW = {
  heading: 'Grow your practice with will services',
  intro: 'Old Mutual Will gives you:',
  bullets: [
    'A fresh way to add value to every client relationship.',
    'A simple way to open estate planning conversations.',
    'The support of a dedicated team, every step of the way',
  ],
  outro:
    'Simply <strong>register as an adviser</strong> on the platform to get started.',
};

export const ADVISER_CHANNEL_CTA = {
  heading: 'Select your channel below',
  subtitle:
    'This will direct you to your channel-specific registration page and dedicated resources for your channel.',
};

// Icons follow the Figma frames: /adviser draws the FAQs card with the
// "conversation" glyph while the channel pages use "question-exchange";
// every Resources card uses the checklist glyph.
const FAQS_CARD = {
  icon: 'conversation',
  title: 'FAQs',
  description:
    'A full range of questions that advisers frequently ask, in one place and easy to reference at any time.',
  buttonText: 'View FAQs',
  route: 'AdviserFaqs',
};

const RESOURCES_CARD = {
  icon: 'checklist',
  title: 'Resources',
  description:
    'Helpful resources, including brochures, guides and how-to videos, to help you use the platform and get started quickly.',
  buttonText: 'View Resources',
  route: 'AdviserResources',
};

export const ADVISER_LINK_CARDS = [FAQS_CARD, RESOURCES_CARD];

// Channel pages: same cards, with the channel-page wording.
export const CHANNEL_LINK_CARDS = [
  {
    ...FAQS_CARD,
    icon: 'question-exchange',
    description:
      'A full range of questions that advisers frequently ask, in one place, and easy to reference at any time.',
  },
  { ...RESOURCES_CARD, title: 'Additional Resources' },
];

// /adviser/faqs closes with the channel selector and the Resources card only.
export const FAQS_PAGE_LINK_CARDS = [
  { ...RESOURCES_CARD, title: 'Additional Resources' },
];
